import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaUser,
  FaUserPlus} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsThreeDotsVertical } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import toast from 'react-hot-toast'
import EditTeacherModal from './EditTeacherModal'
import { Eye, PencilSquare } from 'react-bootstrap-icons'
import { BsEyeFill, BsPencilFill } from 'react-icons/bs'
import { FaEyeSlash, FaEye } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { Card } from 'react-bootstrap'

const GuardianTable = () => {
  const { user, logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const location = useLocation()
  const navigate = useNavigate()
  console.log('USER ', user)
  const { student_id: paramStudentId, course_id: paramCourseId, class_id: paramClassId } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const { logo, name, setInstituteId } = useInstitute();
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editGuardian, setEditGuardian] = useState({
    id: '',
    institute_id: '',
    name: '',
    phone_number: '',
    email: ''})
  const [selectedTeacher, setSelectedTeacher] = useState(null)
  const [institute, setInstitute] = useState('')
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [courses, setCourses] = useState([]);
    const [classes, setClasses] = useState([]);
    const [students, setStudents] = useState([]);
    const [institutes, setInstitutes] = useState([]);
    console.log("Short Data students:", students)

    // State for selected values
    const [selectedCourse, setSelectedCourse] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedStudent, setSelectedStudent] = useState('');
    const [selectedStudentFull, setSelectedStudentFull] = useState(null);
    const [selectedStudentId, setSelectedStudentId] = useState('');
    const [allStudents, setAllStudents] = useState([])

    const isFromURL = Boolean(paramStudentId && paramCourseId && paramClassId);
    const params = new URLSearchParams(location.search)
    const institute_id = params.get('institute_id')

    useEffect(() => {
      if (institute_id) {
        setInstituteId(institute_id)   // ✅ sync URL → context
        Cookies.set('institute_id', institute_id) // optional but good
      }
    }, [institute_id])
    
   // prefill when arriving with URL params
  useEffect(() => {
    if (isFromURL) {
      // store as strings (select value uses string)
      setSelectedCourse(String(paramCourseId));
      setSelectedClass(String(paramClassId));
      setSelectedStudentId(String(paramStudentId));
      // fetch parents for that student immediately
      fetchAllParents(paramStudentId);
    }
  }, [paramStudentId, paramCourseId, paramClassId]); // run once when route params available

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const instituteName = Cookies.get('institute_name')

    console.log('instituteId', instituteId)
    console.log('instituteName', instituteName)

    setInstitute({ instituteId, name: instituteName })
    // Set default institute_id from cookie if available, but allow user to change it
    if (instituteId) {
      setNewParent((prev) => ({
        ...prev,
        'institute-Id': Number(instituteId)}))
    }
  }, [])

  // useEffect(() => {
  //   const institueId = Cookies.get('institute_id')
  //   const userCookie = Cookies.get('user')
  //   let token = null
  //   console.log('InstituteID', institueId)

  //   if (userCookie) {
  //     try {
  //       const user = JSON.parse(userCookie)
  //       token = user.token
  //       console.log('TOKEN:', token)
  //     } catch (err) {
  //       console.error(' Failed to parse user cookie', err)
  //     }
  //   } else {
  //     console.warn('user cookie not found')
  //   }

  //   const fetchFilteredData = async () => {
  //     console.log('Insti ID: ', institueId)
  //     try {
  //       const headers = {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //         'institute-Id': Number(institueId),
  //       }

  //       console.log('Request Headers:', headers)

  //       const response = await axios.get(
  //         BASE_URL+'/parents',
  //         { headers },
  //       )

  //       console.log('Parents response: ', response.data.data)

  //       setData(response.data.data)
  //       // setFilteredData(response.data.data) // ✅ FIXED: show data in table
  //     } catch (error) {
  //       toast.error(error.response?.data?.message || 'Something went wrong')
  //     }
  //   }

  //   fetchFilteredData()
  // }, [loading])
 const fetchParents = async () => {
      const institueId = Cookies.get("institute_id");
      const userCookie = Cookies.get("user");
      let token = null;
      if (userCookie) {
        try {
          const user = JSON.parse(userCookie);
          token = user.token;
        } catch (err) {
          console.error("Failed to parse user cookie", err);
        }
      }

      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
          'institute-Id': Number(institueId)};

        // If we came via URL we already fetched student parents (skip full list)
        if (isFromURL) {
          return;
        }

        const response = await axios.get(
          BASE_URL+"/parents",
          { headers }
        );
        setData(response.data.data || []);
      } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong");
      }
    };

  // main parents list (normal mode fetch)
  useEffect(() => {
   

    fetchParents();
  }, [loading, isFromURL]); // keep loading in deps so refresh works; skip when isFromURL

  useEffect(()=>{
    ApiEndpoints.getAllCourses().then((res)=>setCourses(res.data.data || []))
    .catch(console.err)
    ApiEndpoints.getAllInstitutes().then((res)=>setInstitutes(res.data.data || []))
    .catch(console.err)
  },[])

  // when selectedCourse changes -> fetch classes
  useEffect(() => {
    const fetchClasses = async () => {
      if (!selectedCourse) {
        setClasses([]);
        setSelectedClass("");
        return;
      }
      try {
        const res = await ApiEndpoints.getAllClassesByCourseId(parseInt(selectedCourse));
        const classList = res.data.data || [];
        setClasses(classList);

        // If we came from URL and paramClassId matches one of the fetched classes, keep it
        if (isFromURL && paramClassId) {
          const found = classList.find((c) => String(c.id) === String(paramClassId));
          if (found) {
            setSelectedClass(String(paramClassId));
            return;
          }
        }

        // Otherwise reset class & students
        setSelectedClass("");
        setStudents([]);
        setSelectedStudentId("");
        setSelectedStudentFull(null);
      } catch (error) {
        console.error(error);
        toast.error("Error fetching classes.");
      }
    };

    fetchClasses();
  }, [selectedCourse, isFromURL, paramClassId]);

  // when selectedClass changes -> fetch students of that class
  useEffect(() => {
    const fetchStudentsByClass = async () => {
      if (!selectedClass) return;

      const institueId = Cookies.get("institute_id");
      const userCookie = Cookies.get("user");
      let token = null;
      if (userCookie) {
        try {
          const user = JSON.parse(userCookie);
          token = user.token;
        } catch (err) {
          console.error(" Failed to parse user cookie", err);
        }
      }

      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
          'institute-Id': Number(institueId)};

        const response = await axios.get(
          BASE_URL+`/get/student/by-class?class_id=${parseInt(selectedClass)}`,
          { headers }
        );

        const studentList = response.data.data || [];
        setStudents(studentList);

        // If arriving from URL, pre-select the student (if present in list)
        if (isFromURL && paramStudentId) {
          const found = studentList.find((s) => String(s.id) === String(paramStudentId));
          if (found) {
            setSelectedStudentId(String(found.id));
            setSelectedStudentFull(found);
            // Note: parents for this student already fetched in the initial useEffect,
            // but if you want to fetch again here, you can call fetchAllParents(found.id)
          }
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong");
      }
    };

    fetchStudentsByClass();
  }, [selectedClass, isFromURL, paramStudentId]);

 // Fetch parents for a given student ID (student-specific API)
  const fetchAllParents = async (studentId) => {
    const institueId = Cookies.get("institute_id");
    const userCookie = Cookies.get("user");
    let token = null;
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        token = user.token;
      } catch (err) {
        console.error("Failed to parse user cookie", err);
      }
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
        'institute-Id': Number(institueId)};

      const response = await axios.get(
        BASE_URL+`/students/${studentId}/parents`,
        { headers }
      );
      console.log("Parents fetched:", response.data.parents || []);

  
      
    if (response.data.status === false) {
      setData([]);
      setErrorMessage(response.data.message || "No parent data available");
      toast.error(response.data.message || "No parent data available");
    } else {
      setData(response.data.parents || []);
      setErrorMessage(""); // ✅ clear old message
    }
    } catch (error) {
      setData([])
    setErrorMessage(error.response?.data?.message || "Something went wrong");
    }
  };



const handleStudentChange = (studentId) => {
    if (!studentId) {
      setSelectedStudentId("");
      setSelectedStudentFull(null);
      // reset to full list when no student is selected
      if (!isFromURL) {
        // reload full parents list
        setLoading((l) => !l);
      }
      return;
    }

    const fullData = students.find((std) => String(std.id) === String(studentId));
    setSelectedStudentFull(fullData || null);
    setSelectedStudentId(String(fullData?.id || ""));

    if (studentId) {
      fetchAllParents(studentId);
    }
  };


  const [newParent, setNewParent] = useState({
    name: '',
    phone_number: '',
    email: '',
    password: '',
    institute_id: '',
    confirmPassword:""
  })
  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    // Adjust age if the birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  // Filter Data Based on Search
  const filteredData = data?.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData?.length / itemsPerPage) || 1
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem)

  useEffect(() => {
  if (currentPage > totalPages) {
    setCurrentPage(1);
  }
}, [filteredData, totalPages, currentPage]);

  // useEffect(() => {
  //   if (currentPage > totalPages && totalPages !== 0) {
  //     setCurrentPage(1)
  //   }
  // }, [filteredData, totalPages])

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewParent((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewParent((prev) => ({
        ...prev,
        dob: value,
        age: age.toString()}))
    } else {
      setNewParent((prev) => ({ ...prev, [name]: value }))
    }
  }

  
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);


  // Add New Parent
  const handleSave = async (e) => {
    e.preventDefault()

    if(newParent.password !== newParent.confirmPassword){
      toast.error("Password do not match")
      return
    }
    try {
      setLoading(true)

      const headers = {
        Authorization: `Bearer ${user.token}`}
      const payload = {
        ...newParent,
        headers}

      console.log('Sending data: ', newParent)
      const response = await ApiEndpoints.addParent({
        ...payload,
        password: newParent.password})
   
      
      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        setShowModal(false)
      } 
       else {
      // Dynamically get the first error from any field
      const errors = response.data.errors;
      if (errors) {
        const firstKey = Object.keys(errors)[0];
        toast.error(errors[firstKey][0]);
      } else {
        toast.error(response.data.message || "Validation failed");
      }
    }
  } catch (err) {
      
     console.error(err);

    // Handle API errors dynamically
    const errors = err.response?.data?.errors;
    if (errors) {
      const firstKey = Object.keys(errors)[0];
      toast.error(errors[firstKey][0]);
    } else {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
    } finally {
      setLoading(false);
    }
  }

  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const [showFilterCard, setShowFilterCard] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const handleRefresh = () => {
    // clear selected filters
    setSelectedCourse("");
    setSelectedClass("");
    setSelectedStudentId("");
    setSearch("");

    // reload all parents
    fetchParents([]);
  };

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }

  // Handler for View Assigned Students action
  const handleViewAssignedStudents = (guardian) => {
    console.log('View Assigned Students for:', guardian)
    if (guardian?.id) {
      navigate(`/Guardian/${guardian.id}/Students`)
    } else {
      toast.error('Guardian ID not found')
    }
  }

  // Handler for Assign Student action
  const handleAssignStudent = (guardian) => {
    console.log('Assign Student for:', guardian)
    if (guardian?.id) {
      // Pass guardian data via state to avoid fetching again
      navigate(`/Guardian/${guardian.id}/AssignStudents`, {
        state: {
          guardian: {
            id: guardian.id,
            name: guardian.name,
            email: guardian.email}
        }
      })
    } else {
      toast.error('Guardian ID not found')
    }
  }

  const handleGuardianChangePassword = (guardian) => {
    const targetUserId = guardian?.user_id || guardian?.id
    if (targetUserId && guardian?.email) {
      navigate(`/Guardian/ChangePassword/${targetUserId}`, {
        state: {
          guardian_id: guardian.id,
          user_id: targetUserId,
          email: guardian.email}})
    } else {
      toast.error('Guardian details not found')
    }
  }

  const handleEditGuardian = (guardian) => {
    setEditGuardian({
      id: guardian?.id || '',
      institute_id: guardian?.institute_id || guardian?.['institute-Id'] || '',
      name: guardian?.name || '',
      phone_number: guardian?.phone_number || '',
      email: guardian?.email || ''})
    setShowEditModal(true)
  }

  const handleEditInputChange = (e) => {
    const { name, value } = e.target
    setEditGuardian((prev) => ({ ...prev, [name]: value }))
  }

  const handleUpdateGuardian = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const headers = {
        Accept: 'application/json',
        Authorization: `Bearer ${user.token}`,
        'Content-Type': 'application/json'}

      const response = await axios.put(
        `${BASE_URL}/guardian/${editGuardian.id}`,
        {
          name: editGuardian.name,
          phone_number: editGuardian.phone_number,
          email: editGuardian.email},
        { headers },
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data?.message || 'Guardian updated successfully')
        setShowEditModal(false)
        setLoading((prev) => !prev)
      } else {
        toast.error(response.data?.message || 'Failed to update guardian')
      }
    } catch (err) {
      const errors = err.response?.data?.errors
      if (errors) {
        const firstKey = Object.keys(errors)[0]
        toast.error(errors[firstKey][0])
      } else {
        toast.error(err.response?.data?.message || 'Something went wrong')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          /* Ensure dropdown menu can overflow table boundaries */
          .table td {
            overflow: visible !important;
            user-select: text;
          }

          .table tbody tr {
            overflow: visible !important;
            cursor: default;
          }

          /* Fix dropdown menu positioning and z-index - ensure it appears above table container */
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }

          /* Ensure table container allows dropdown overflow but prevents scrolling */
          .table-container {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }

          /* Ensure dropdown wrapper has proper z-index */
          .dropdown-wrapper {
            position: relative;
            z-index: 9999 !important;
          }

          /* Ensure Card allows dropdown to overflow */
          .table-card {
            overflow: visible !important;
          }

          /* Table wrapper inside card - allows dropdown to escape */
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            max-height: none !important;
            position: relative;
          }

          /* Ensure dropdown menu renders outside container */
          .dropdown-menu.show {
            z-index: 9999 !important;
            position: absolute !important;
            transform: none !important;
          }

          /* Prevent table from clipping dropdown */
          .table {
            overflow: visible !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Guardian Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Guardians
              </h3>
              {/* <button
                onClick={() => {
                  const instituteId = Cookies.get('institute_id')
                  setNewParent({
                    name: "",
                    phone_number: "",
                    email: "",
                    password: "",
                    'institute-Id': Number(instituteId) || "",
                    confirmPassword: ""});
                  setShowModal(true)
                }}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#223843',
                  border: 'none',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Guardian"
              >
                <FaUserPlus size={18} />
              </button> */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
            <button
              type="button"
              className="d-none d-md-flex align-items-center justify-content-center"
              onClick={() => {
                const instituteId = Cookies.get('institute_id')
                setNewParent({
                  name: '',
                  phone_number: '',
                  email: '',
                  password: '',
                  'institute-Id': Number(instituteId) || '',
                  confirmPassword: ''})
                setShowModal(true)
              }}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New"
            >
              <FaUserPlus size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New Guardian
              </span>
            </button>
          </div>

          <div className="d-md-none d-flex justify-content-end mb-4">
            <button
              type="button"
              onClick={() => {
                const instituteId = Cookies.get('institute_id')
                setNewParent({
                  name: '',
                  phone_number: '',
                  email: '',
                  password: '',
                  'institute-Id': Number(instituteId) || '',
                  confirmPassword: ''})
                setShowModal(true)
              }}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New"
            >
              <FaUserPlus size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New Guardian
              </span>
            </button>
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Guardians
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find guardians quickly by name, phone, or email
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-3">
                    <Col xs={12}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Guardian Name
                        </label>
                        <div style={{ position: 'relative' }}>
                          <BsSearch 
                            style={{ 
                              position: 'absolute', 
                              left: '12px', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              color: '#6b7280',
                              fontSize: '16px',
                              zIndex: 1}} 
                          />
                          <Form.Control
                            type="text"
                            placeholder="Enter guardian name..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                              paddingLeft: '40px',
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card className="table-card" style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'visible', backgroundColor: '#ffffff', position: 'relative' }}>
          <div className="table-wrapper" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative', marginBottom: '0' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Phone</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Email</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif',textAlign: 'left' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems?.length > 0 ? (
                currentItems?.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{highlightText(item.name, search)}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.phone_number}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.email}</Td>
                    <Td className="text-center" style={{ padding: '16px', border: 'none', textAlign: 'center' }}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id={`dropdown-${item.id || index}`}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'transparent',
                            border: '1px solid #D1D3D4',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease'}}
                          className="dropdown-toggle-no-caret"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.borderColor = '#223843'
                            e.currentTarget.style.color = '#ffffff'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent'
                            e.currentTarget.style.borderColor = '#D1D3D4'
                            e.currentTarget.style.color = '#111827'
                          }}
                        >
                          <BsThreeDotsVertical style={{ color: 'inherit' }} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            borderRadius: '8px',
                            border: '1px solid #D1D3D4',
                            padding: '8px',
                            minWidth: '180px'}}
                        >
                          <Dropdown.Item
                            onClick={() => handleEditGuardian(item)}
                            style={{
                              fontSize: '13px',
                              padding: '10px 12px',
                              color: '#111827',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              transition: 'all 0.2s ease',
                              borderRadius: '6px',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#F59E0B'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsPencilFill size={18} /> Edit Guardian
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => handleViewAssignedStudents(item)}
                            style={{
                              fontSize: '13px',
                              padding: '10px 12px',
                              color: '#111827',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              transition: 'all 0.2s ease',
                              borderRadius: '6px',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsEyeFill size={18} /> View Assigned Students
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => handleAssignStudent(item)}
                            style={{
                              fontSize: '13px',
                              padding: '10px 12px',
                              color: '#111827',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              transition: 'all 0.2s ease',
                              borderRadius: '6px',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsPencilFill size={18} /> Assign Student
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleGuardianChangePassword(item)}
                            style={{
                              fontSize: '13px',
                              padding: '10px 12px',
                              color: '#111827',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              transition: 'all 0.2s ease',
                              borderRadius: '6px',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#0EA5E9'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsPencilFill size={18} /> Change Password
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="4" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    {errorMessage || "No records found"}
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData?.length || 0}
          itemLabel="guardians"
        />
        </div>
      </div>

      {/* Add New Guardian Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New Guardian</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Institute Selection Field */}
            <Form.Group className="mb-3">
              <Form.Label>Institute *</Form.Label>
              <Form.Select
                name="institute_id"
                value={newParent.institute_id || ''}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              >
                <option value="">Select Institute</option>
                {institutes.map((institute) => (
                  <option
                    key={institute.id}
                    value={institute.institute_id}
                  >
                    {institute.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newParent.name}
                onChange={handleInputChange}
                placeholder="Enter Guardian's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

          {/* Phone Number Field */}
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="text"
                name="phone_number"
                value={newParent.phone_number}
                onChange={handleInputChange}
                placeholder="Enter Phone Number"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Email ID Field */}
            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newParent.email}
                onChange={handleInputChange}
                placeholder="Enter Email ID"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newParent.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

              <Form.Group className="mb-3">
        <Form.Label>Re-enter Password *</Form.Label>
        <div className="input-group">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={newParent.confirmPassword}
            onChange={handleInputChange}
            placeholder="Re-enter Password"
            className="p-2 border rounded"
            required
          />
          <Button
            variant="outline-secondary"
            onClick={toggleConfirmPasswordVisibility}
            type="button"
            title={showConfirmPassword ? "Hide Password" : "Show Password"}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </Button>
        </div>
      </Form.Group>


            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save Guardian
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="text-white"
          style={{ backgroundColor: '#223843' }}
        >
          <Modal.Title>Edit Guardian</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdateGuardian}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={editGuardian.name}
                onChange={handleEditInputChange}
                placeholder="Enter Guardian's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="text"
                name="phone_number"
                value={editGuardian.phone_number}
                onChange={handleEditInputChange}
                placeholder="Enter Phone Number"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={editGuardian.email}
                disabled
                placeholder="Enter Email ID"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowEditModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Update Guardian
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      {/* <EditGuardianModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        teacher={selectedTeacher}
      /> */}
      {/* <EditTeacherModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        teacher={selectedTeacher}
      /> */}
    </>
  )
}

export default GuardianTable
